/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import TextError from "utils/TextError";
import * as Yup from "yup";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard standardized components
import CreateButton from "components/standardized-components/CreateButton";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { CSVLink } from "react-csv";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  createDynamicColumn,
  createNewAsset,
  deleteAsset,
  getAssetTypes,
  getAssets,
  getBins,
  getDownloadAssets,
  getDynamicColumn,
  getMappedBinsByRfid,
  getSubModulesByRoleId,
  getUnmappedBins,
  getUnmappedPallets,
  mapAsset,
  updateAsset,
  uploadAssetMaster,
} from "../../store";

// React-Select component and styling
import Select from "react-select";
import "../../index.css";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import DeleteButton from "components/standardized-components/DeleteButton";
import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import EditButton from "components/standardized-components/EditButton";
import StandardButton from "components/standardized-components/StandardButton";
import UploadButton from "components/standardized-components/UploadButton";
import { addMinutes, format } from "date-fns";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};
const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForPicklistViewModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "scroll",
  width: { xs: 350, lg: 1000 },
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const AssetMaster = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getAssets,
  getAssetsReducer,
  createNewAsset,
  getAssetTypes,
  assetTypes,
  deleteAsset,
  updateAsset,
  getUnmappedBins,
  getUnmappedPallets,
  getUnmappedBinsReducer,
  getUnmappedPalletsReducer,
  mapAsset,
  getMappedBinsByRifdReducer,
  getDownloadAssetsReducer,
  uploadAssetMaster,
  getDownloadAssets,
  getMappedBinsByRfid,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;

  let roleId = loginDetails.data.roleId;
  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let assetMasterModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "1f5af71a-95cd-4ea6-93df-7c7d57cdb254",
  );
  let createAccess = assetMasterModule
    ? assetMasterModule.actionId.includes(
        "569973a8-609c-452b-871b-cafb8410efc4",
      )
    : null;
  let viewAccess = assetMasterModule
    ? assetMasterModule.actionId.includes(
        "9a2f75ef-da73-4e8b-9d43-86b8c91b59d3",
      )
    : null;
  let viewSuidAccess = assetMasterModule
    ? assetMasterModule.actionId.includes(
        "70bcbb7f-e15e-447b-8820-369725a7777a",
      )
    : null;
  let downloadAccess = assetMasterModule
    ? assetMasterModule.actionId.includes(
        "83fa1dc2-17d9-4f32-b914-067f4c0bca1e",
      )
    : null;
  let downloadTemplateAccess = assetMasterModule
    ? assetMasterModule.actionId.includes(
        "bbaa7e9d-a83f-4581-b87c-ceaf7211f06a",
      )
    : null;
  let uploadAccess = assetMasterModule
    ? assetMasterModule.actionId.includes(
        "49ddb7ba-79ad-483d-8f9e-8b031d9320cc",
      )
    : null;
  let editAccess = assetMasterModule
    ? assetMasterModule.actionId.includes(
        "3c4c3bd5-5784-4a52-b00d-686b9754526c",
      )
    : null;
  let deleteAccess = assetMasterModule
    ? assetMasterModule.actionId.includes(
        "5deb3502-bc8e-4bbf-89a3-439b6b37f24e",
      )
    : null;
  let mapAccess = assetMasterModule
    ? assetMasterModule.actionId.includes(
        "485961a6-2911-492a-9fdd-6afa416722f9",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  useEffect(() => {
    getAssets(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject, refresh]);
  useEffect(() => {
    getDownloadAssets(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject, refresh]);

  const [state, setState] = useState({
    columns: [
      { Header: "Asset Code", accessor: "assetCode" },

      { Header: "Asset Description", accessor: "assetName" },
      { Header: "Asset Type", accessor: "assetTypeCode" },
      { Header: "Printer Ip ", accessor: "printerIp" },
      { Header: "Printer Port", accessor: "printerPort" },

      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [errorMsgForCreate, setErrorMsgForCreate] = useState("");
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [errorMsgForMapAsset, setErrorMsgForMapAsset] = useState("");

  const [isErrorCreateNewAsset, setIsErrorCreateNewAsset] = useState(false);
  const [isSuccessCreateNewAsset, setIsSuccessCreateNewAsset] = useState(false);

  useEffect(() => {
    if (isErrorCreateNewAsset) {
      setTimeout(() => {
        setIsErrorCreateNewAsset(false);
      }, 3000);
    }
  }, [isErrorCreateNewAsset]);

  useEffect(() => {
    if (isSuccessCreateNewAsset) {
      setTimeout(() => {
        setIsSuccessCreateNewAsset(false);
      }, 3000);
    }
  }, [isSuccessCreateNewAsset]);

  const [assetTypeSelected, setAssetTypeSelected] = useState("");
  const [assetTypeOptions, setAssetTypeOptions] = useState([]);

  useEffect(() => {
    let tempAssetTypeOptions = [];
    let data = assetTypes.assetTypes.data ? assetTypes.assetTypes.data : [];

    data.map((asset) => {
      tempAssetTypeOptions.push({
        label: asset.assetTypeCode,
        value: asset.assetTypeId,
      });
    });

    setAssetTypeOptions(tempAssetTypeOptions);
  }, [assetTypes]);

  const [openBinViewModal, setOpenBinViewModal] = useState(false);

  const handleOpenViewBinModal = (assets) => {
    setOpenBinViewModal(true);
  };

  const handleCloseViewBinModal = () => {
    setOpenBinViewModal(false);
  };

  const [suidTable, setSuidTable] = useState({
    columns: [
      { Header: "Bin/Pallet Code", accessor: "binCode", align: "left" },
      { Header: "Bin/Pallet Name", accessor: "binName" },

      // { Header: "Created Date", accessor: "cd", align: "left" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      // { Header: "location Code", accessor: "locationCode", align: "left" },
    ],
    rows: [],
  });

  const [loading2, setLoading2] = useState(false);

  const { columns: binColumns, rows: binRows } = suidTable;
  useEffect(() => {
    let tempGRN = [];
    let data = getMappedBinsByRifdReducer.mappedBins.data
      ? getMappedBinsByRifdReducer.mappedBins.data
      : [];
    setLoading2(getMappedBinsByRifdReducer.loading);
    data.map((singleSuid) => {
      const formatDate = new Date(singleSuid.cd);

      const singleUser = {
        binCode: singleSuid.code,
        binName: singleSuid.name,
        lotSerialNo: `${singleSuid.lotNumber ? singleSuid.lotNumber : "NA"} / ${
          singleSuid.serialNumber ? singleSuid.serialNumber : "NA"
        }`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: singleSuid.cd,
        locationCode: singleSuid.locationCode,
      };
      tempGRN.push(singleUser);
    });
    setSuidTable({ ...suidTable, rows: tempGRN });
  }, [getMappedBinsByRifdReducer]);
  const [loading, setLoading] = useState(true);
  const [rfid, setRfid] = useState("");
  useEffect(() => {
    getMappedBinsByRfid(rfid, jwtToken);
  }, [rfid]);

  useEffect(() => {
    let tempAsset = [];
    let data = getAssetsReducer.assets.data ? getAssetsReducer.assets.data : [];
    setPaginationObj(getAssetsReducer.assets?.pagination);
    setLoading(getAssetsReducer.loading);
    data.map((assets) => {
      const formatDate = new Date(assets.cd);
      const assetsObject = {
        assetCode: assets.assetCode,
        assetName: assets.assetName,
        assetTypeCode: assets.assetTypeCode,
        printerIp: assets.printerIp,
        printerPort: assets.printerPort,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: assets.cd,
        isEditable: assets.isEditable,
        action: (
          <div>
            {editAccess && (
              <EditButton
                tooltip="Edit Asset"
                disabled={assets.isEditable === 0}
                variant="gradient"
                color="success"
                iconOnly
                style={{ borderRadius: "5px" }}
                size="small"
                type="button"
                onClick={() => handleOpenUpdateAssetModal(assets)}
                // style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}

            {deleteAccess && (
              <DeleteButton
                tooltip="Delete Asset"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginLeft: "5px", borderRadius: "5px" }}
                size="small"
                onClick={() => handleOpenDeleteAssetModal(assets)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}

            {mapAccess &&
            assets.assetTypeCode == "RFID" &&
            assets.isEditable === 1 ? (
              <StandardButton
                tooltip="Map Asset"
                // disabled={assets.isEditable === 0}
                variant="gradient"
                color="success"
                iconOnly
                icon="map"
                size="small"
                type="button"
                onClick={() => {
                  handleOpenMapAssetModal(assets);
                  getUnmappedBins(jwtToken);
                  getUnmappedPallets(jwtToken);
                }}
                style={{
                  marginLeft: "5px",
                  borderRadius: "5px",

                  // marginLeft: assets.isEditable === 0 ? "0rem" : undefined,
                  background: assets.isEditable === 0 ? "grey" : undefined,
                  color: assets.isEditable === 0 ? "white" : undefined,
                  opacity: assets.isEditable === 0 ? 0.5 : undefined,
                }}
              >
                <Icon>map</Icon>
              </StandardButton>
            ) : (
              <StandardButton
                tooltip="Map Asset"
                disabled
                variant="gradient"
                size="small"
                color="success"
                iconOnly
                icon="map"
                type="button"
                onClick={() => {
                  handleOpenMapAssetModal(assets);
                  getUnmappedBins(jwtToken);
                  getUnmappedPallets(jwtToken);
                }}
                style={{
                  marginLeft: "5px",
                  borderRadius: "5px",
                  // marginLeft: assets.isEditable === 0 ? "0rem" : undefined,
                  background: assets.isEditable === 0 ? "grey" : undefined,
                  color: assets.isEditable === 0 ? "white" : undefined,
                  opacity: assets.isEditable === 0 ? 0.5 : undefined,
                }}
              >
                <Icon>map</Icon>
              </StandardButton>
            )}
            {assets.assetTypeCode == "RFID" && assets.isEditable === 0 ? (
              <Tooltip title="View">
                <MDButton
                  variant="gradient"
                  color="info"
                  // disabled={assets.isEditable === 1}
                  // disabled={!viewGRN}
                  iconOnly
                  size="small"
                  type="button"
                  onClick={() => {
                    handleOpenViewBinModal(assets);
                    setRfid(assets.assetCode);
                  }}
                  style={{
                    marginLeft: "5px",
                    borderRadius: "5px",

                    // marginLeft: assets.isEditable === 1 ? "0rem" : undefined,
                    background: assets.isEditable === 1 ? "grey" : undefined,
                    color: assets.isEditable === 1 ? "white" : undefined,
                    opacity: assets.isEditable === 1 ? 0.5 : undefined,
                  }}
                >
                  <Icon> visibility_icon </Icon>
                </MDButton>
              </Tooltip>
            ) : (
              <Tooltip title="View">
                <MDButton
                  variant="gradient"
                  color="info"
                  // disabled={assets.isEditable === 1}
                  disabled
                  iconOnly
                  size="small"
                  type="button"
                  onClick={() => {
                    handleOpenViewBinModal(assets);
                    setRfid(assets.assetCode);
                  }}
                  style={{
                    marginLeft: "5px",
                    borderRadius: "5px",
                    // marginLeft: assets.isEditable === 1 ? "0rem" : undefined,
                    background: assets.isEditable === 1 ? "grey" : undefined,
                    color: assets.isEditable === 1 ? "white" : undefined,
                    opacity: assets.isEditable === 1 ? 0.5 : undefined,
                  }}
                >
                  <Icon> visibility_icon </Icon>
                </MDButton>
              </Tooltip>
            )}
          </div>
        ),
      };
      tempAsset.push(assetsObject);
    });

    viewAccess && setState({ ...state, rows: tempAsset });
  }, [getAssetsReducer]);

  const [download, setDownloadData] = useState("");
  useEffect(() => {
    let tempAsset = [];
    let data = getDownloadAssetsReducer.assets.data
      ? getDownloadAssetsReducer.assets.data
      : [];
    setPaginationObj(getDownloadAssetsReducer.assets?.pagination);
    setLoading(getDownloadAssetsReducer.loading);
    data.map((assets) => {
      const formatDate = new Date(assets.cd);
      const assetsObject = {
        assetCode: assets.assetCode,
        assetName: assets.assetName,
        assetTypeCode: assets.assetTypeCode,
        printerIp: assets.printerIp,
        printerPort: assets.printerPort,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: assets.cd,

        isEditable: assets.isEditable,
        action: (
          <div>
            {editAccess && (
              <EditButton
                tooltip="Edit Asset"
                disabled={assets.isEditable === 0}
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateAssetModal(assets)}
                // style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}

            {deleteAccess && (
              <DeleteButton
                tooltip="Delete Asset"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginLeft: "5px" }}
                onClick={() => handleOpenDeleteAssetModal(assets)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}

            {mapAccess &&
            assets.assetTypeCode == "RFID" &&
            assets.isEditable === 1 ? (
              <StandardButton
                tooltip="Map Asset"
                // disabled={assets.isEditable === 0}
                variant="gradient"
                color="success"
                iconOnly
                icon="map"
                type="button"
                onClick={() => {
                  handleOpenMapAssetModal(assets);
                  getUnmappedBins(jwtToken);
                  getUnmappedPallets(jwtToken);
                }}
                style={{
                  marginLeft: "5px",
                  // marginLeft: assets.isEditable === 0 ? "0rem" : undefined,
                  background: assets.isEditable === 0 ? "grey" : undefined,
                  color: assets.isEditable === 0 ? "white" : undefined,
                  opacity: assets.isEditable === 0 ? 0.5 : undefined,
                }}
              >
                <Icon>map</Icon>
              </StandardButton>
            ) : (
              <StandardButton
                tooltip="Map Asset"
                disabled
                variant="gradient"
                color="success"
                iconOnly
                icon="map"
                type="button"
                onClick={() => {
                  handleOpenMapAssetModal(assets);
                  getUnmappedBins(jwtToken);
                  getUnmappedPallets(jwtToken);
                }}
                style={{
                  marginLeft: "5px",
                  // marginLeft: assets.isEditable === 0 ? "0rem" : undefined,
                  background: assets.isEditable === 0 ? "grey" : undefined,
                  color: assets.isEditable === 0 ? "white" : undefined,
                  opacity: assets.isEditable === 0 ? 0.5 : undefined,
                }}
              >
                <Icon>map</Icon>
              </StandardButton>
            )}
            {assets.assetTypeCode == "RFID" && assets.isEditable === 0 ? (
              <Tooltip title="View">
                <MDButton
                  variant="gradient"
                  color="info"
                  // disabled={assets.isEditable === 1}
                  // disabled={!viewGRN}
                  iconOnly
                  type="button"
                  onClick={() => {
                    handleOpenViewBinModal(assets);
                    setRfid(assets.assetCode);
                  }}
                  style={{
                    marginLeft: "5px",
                    // marginLeft: assets.isEditable === 1 ? "0rem" : undefined,
                    background: assets.isEditable === 1 ? "grey" : undefined,
                    color: assets.isEditable === 1 ? "white" : undefined,
                    opacity: assets.isEditable === 1 ? 0.5 : undefined,
                  }}
                >
                  <Icon> visibility_icon </Icon>
                </MDButton>
              </Tooltip>
            ) : (
              <Tooltip title="View">
                <MDButton
                  variant="gradient"
                  color="info"
                  // disabled={assets.isEditable === 1}
                  disabled
                  iconOnly
                  type="button"
                  onClick={() => {
                    handleOpenViewBinModal(assets);
                    setRfid(assets.assetCode);
                    // setAssetCode(assets.assetCode);
                  }}
                  style={{
                    marginLeft: "5px",
                    // marginLeft: assets.isEditable === 1 ? "0rem" : undefined,
                    background: assets.isEditable === 1 ? "grey" : undefined,
                    color: assets.isEditable === 1 ? "white" : undefined,
                    opacity: assets.isEditable === 1 ? 0.5 : undefined,
                  }}
                >
                  <Icon> visibility_icon </Icon>
                </MDButton>
              </Tooltip>
            )}
          </div>
        ),
      };
      tempAsset.push(assetsObject);
    });

    setDownloadData(tempAsset);
  }, [getDownloadAssetsReducer]);

  const handleAssetTypeChange = (selectedZone) => {
    setAssetTypeSelected(selectedZone);
  };

  let typeOptions = [
    {
      label: "Bin",
      value: "bin",
    },
    {
      label: "Pallet",
      value: "pallet",
    },
  ];

  const [masterOptions, setMasterTypeOptions] = useState([]);

  const [selectedType, setSelectedType] = useState("");

  const handleTypeChange = (selectedMaster) => {
    setSelectedType(selectedMaster);
    setSelectedMaster("");
  };

  useEffect(() => {
    let tempBinPalletOptions = [];
    let data;
    if (selectedType?.value == "bin") {
      data = getUnmappedBinsReducer.unBins.data
        ? getUnmappedBinsReducer.unBins.data
        : [];
    }

    if (selectedType?.value == "pallet") {
      data = getUnmappedPalletsReducer.unPallets.data
        ? getUnmappedPalletsReducer.unPallets.data
        : [];
    }
    data?.map((asset) => {
      tempBinPalletOptions.push({
        label: selectedType?.value == "bin" ? asset.binCode : asset.palletCode,
        value: selectedType?.value == "bin" ? asset.binId : asset.palletId,
      });
    });

    setMasterTypeOptions(tempBinPalletOptions);
  }, [assetTypes, selectedType]);

  const [selectedMaster, setSelectedMaster] = useState("");

  const handleMasterChange = (selectedMaster) => {
    setSelectedMaster(selectedMaster);
  };

  const [openCreateAssetModal, setOpenCreateAssetModal] = useState(false);

  const handleOpenCreateAssetModal = () => {
    getAssetTypes(jwtToken);
    setOpenCreateAssetModal(true);
    // formikForCreateAsset.setValues(initialValueForCreateAsset);
    // formikForCreateAsset.setTouched({});
    // formikForCreateAsset.setErrors({});
    setAssetTypeSelected("");
  };

  const handleCloseCreateAssetModal = () => {
    setOpenCreateAssetModal(false);
    setAssetTypeSelected("");
  };

  const initialValueForCreateAsset = {
    assetType: "",
    assetName: "",
    ip: "",
    port: "",
  };

  let isRequired = true;

  const validationSchema = Yup.object({
    // assetName: isRequired
    //   ? Yup.string().required("Enter the Asset Name")
    //   : Yup.string().notRequired(),
    assetCode: Yup.string().required("Enter the Asset Code"),
  });

  const [buttonName, setButtonName] = useState("Create Asset");
  const onSubmitForCreateAssetMaster = async (values, { resetForm }) => {
    setButtonName("Please wait...");
    let payload = {
      assetTypeId: assetTypeSelected?.value,
      assetName: values.assetName.trim(),
      assetCode: values.assetCode.trim(),
      printerIp: values.ip,
      printerPort: values.port,
      userId: userId,
    };

    let res = await createNewAsset(payload, jwtToken);

    if (res.status) {
      setIsSuccessCreateNewAsset(true);
      getAssets(pageNo, rowsPerPage, searchObject, jwtToken);
      setAssetTypeSelected("");
      setTimeout(() => {
        setButtonName("Create Asset");
        handleCloseCreateAssetModal();
      }, 2250);

      resetForm();
    }
    if (!res.status) {
      setErrorMsgForCreate(res?.data?.data?.msg);
      setIsErrorCreateNewAsset(true);
      setButtonName("Create Asset");
    }
  };

  const formikForCreateAsset = useFormik({
    initialValues: initialValueForCreateAsset,
    validationSchema: validationSchema,
    onSubmit: onSubmitForCreateAssetMaster,
  });

  const [openDeleteAssetModal, setOpenDeleteAssetModal] = useState(false);
  const [singleAssetDataForDelete, setSingleAssetDataForDelete] = useState({});

  const handleOpenDeleteAssetModal = (asset = {}) => {
    setSingleAssetDataForDelete(asset);
    setOpenDeleteAssetModal(true);
  };
  const handleCloseDeleteAssetModal = () => {
    setOpenDeleteAssetModal(false);
    setAssetTypeSelected("");
  };

  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");

  const [isErrorDeleteAsset, setIsErrorDeleteAsset] = useState(false);
  const [isSuccessDeleteAsset, setIsSuccessDeleteAsset] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAsset) {
      setTimeout(() => {
        setIsErrorDeleteAsset(false);
      }, 3000);
    }
  }, [isErrorDeleteAsset]);

  useEffect(() => {
    if (isSuccessDeleteAsset) {
      setTimeout(() => {
        setIsSuccessDeleteAsset(false);
      }, 3000);
    }
  }, [isSuccessDeleteAsset]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteAssetData = async () => {
    setDeleteButtonName("Please wait...");
    let assetId = singleAssetDataForDelete.assetId;

    let response = await deleteAsset(assetId, userId, jwtToken);

    if (response.status) {
      setIsSuccessDeleteAsset(true);
      getAssets(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseDeleteAssetModal();
        setDeleteButtonName("Delete");
      }, 2250);
    }
    if (!response.status) {
      setErrorMsgForDelete(response?.data?.data?.msg);
      setIsErrorDeleteAsset(true);
      setDeleteButtonName("Delete");
    }
  };

  const [openUpdateAssetModal, setOpenUpdateAssetModal] = useState(false);
  const [singleAssetDataForUpdate, setAssetDataForUpdate] = useState({});
  const handleOpenUpdateAssetModal = (Asset = {}) => {
    setAssetDataForUpdate(Asset);
    setOpenUpdateAssetModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };
  const handleCloseUpdateAssetModal = () => {
    setOpenUpdateAssetModal(false);
    formikForUpdate.setErrors({});
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const initialValueForUpdate = {
    assetName: singleAssetDataForUpdate.assetName,
    printerIp: singleAssetDataForUpdate.printerIp,
    printerPort: singleAssetDataForUpdate.printerPort,
  };

  const validationSchemaForUpdate = Yup.object({
    assetName: Yup.string().required("Enter the asset description!"),
  });

  const [editButtonName, setEditButtonName] = useState("Submit");
  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      assetName: values.assetName.trim(),
      assetId: singleAssetDataForUpdate.assetId,
      userId: userId,
      printerIp: values.printerIp ? values.printerIp : "",
      printerPort: values.printerPort ? values.printerPort : "",
    };
    let res = await updateAsset(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getAssets(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        setEditButtonName("Submit");
        handleCloseUpdateAssetModal();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Submit");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    validationSchema: validationSchemaForUpdate,
    enableReinitialize: true,
  });

  const [openMapAssetModal, setOpenMapAssetModal] = useState(false);
  const [singleAssetDataForMapAsset, setSingleAssetDataForMapAsset] = useState(
    {},
  );

  const handleOpenMapAssetModal = (Asset = {}) => {
    setOpenMapAssetModal(true);
    setSingleAssetDataForMapAsset(Asset);
    setSelectedType("");
    setSelectedMaster("");
  };

  const handleCloseMapAssetModal = () => {
    setOpenMapAssetModal(false);
    setAssetTypeSelected("");
  };

  const [isErrorForMapAsset, setIsErrorForMapAsset] = useState(false);
  const [isSuccessForMapAsset, setIsSuccessForMapAsset] = useState(false);

  useEffect(() => {
    if (isErrorForMapAsset) {
      setTimeout(() => {
        setIsErrorForMapAsset(false);
      }, 3000);
    }
  }, [isErrorForMapAsset]);

  useEffect(() => {
    if (isSuccessForMapAsset) {
      setTimeout(() => {
        setIsSuccessForMapAsset(false);
      }, 3000);
    }
  }, [isSuccessForMapAsset]);

  const initialValueForMapAsset = {
    type: "",
  };

  const validationSchemaForMapAsset = Yup.object({
    // type: Yup.string().required("Enter the asset type!"),
  });

  const [mapButtonName, setMapButtonName] = useState("Submit");

  const onSubmitForForMapAsset = async (values, { resetForm }) => {
    setMapButtonName("Please wait...");
    let payload;

    if (selectedType?.value == "bin") {
      payload = {
        binId: selectedMaster.value,

        assetId: singleAssetDataForMapAsset.assetId,
        userId: userId,
      };
    }

    if (selectedType?.value == "pallet") {
      payload = {
        palletId: selectedMaster.value,

        assetId: singleAssetDataForMapAsset.assetId,
        userId: userId,
      };
    }

    let res = await mapAsset(payload, selectedType?.value, jwtToken);

    if (res.status) {
      setIsSuccessForMapAsset(true);
      getAssets(pageNo, rowsPerPage, searchObject, jwtToken);
      setAssetTypeSelected("");
      setSelectedType("");
      setSelectedMaster("");
      setTimeout(() => {
        setMapButtonName("Submit");
        handleCloseMapAssetModal();
      }, 2250);
      resetForm();
    }
    if (!res.status) {
      setErrorMsgForMapAsset(res?.data?.data?.msg);
      setIsErrorForMapAsset(true);
      setMapButtonName("Submit");
    }
  };

  const formikForMapAsset = useFormik({
    initialValues: initialValueForMapAsset,
    validationSchema: validationSchemaForMapAsset,
    onSubmit: onSubmitForForMapAsset,
  });

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);

  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };

  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    let data = new FormData();

    data.append("userId", userId);
    data.append("asset", uploadCsvData);

    let res = await uploadAssetMaster(data, jwtToken);

    if (res.status) {
      getAssets(pageNo, rowsPerPage, searchObject, jwtToken);
      setUploadCsvFilter(false);
      DataUploadSuccessNotification();
    }
    if (!res.status) {
      DataUploadFailureNotification(res?.data?.data?.msg);
    }
  };
  const headers = [
    {
      label: "assetCode",
      key: "assetCode",
    },
    {
      label: "assetName",
      key: "assetName",
    },
    { label: "assetTypeCode", key: "assetTypeCode" },
    { label: "createdDate", key: "createdDate" },
    { label: "printerIpValue", key: "printerIpValue" },
    { label: "printerPort", key: "printerPort" },
  ];

  const headers2 = [
    {
      label: "assetCode",
      key: "assetCode",
    },
    {
      label: "assetName",
      key: "assetName",
    },
    { label: "assetTypeCode", key: "assetTypeCode" },
    { label: "createdDate", key: "createdDate" },
    { label: "printerIp", key: "printerIp" },
    { label: "printerPort", key: "printerPort" },
  ];

  const csvLink = {
    filename: "Assets List.csv",
    headers: headers2,
    data: download,
  };

  const csvLink2 = {
    filename: "Asset Template.csv",
    headers: headers,
    data: [],
  };

  const subModuleId = "1f5af71a-95cd-4ea6-93df-7c7d57cdb254";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getAssets(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={0} pb={3} mb={-2.5}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox color="text" p={0} px={2} mt={0} mb={-2}>
                  {createAccess && (
                    <CreateButton
                      tooltip="Create Asset"
                      color="info"
                      variant="contained"
                      type="button"
                      onClick={handleOpenCreateAssetModal}
                      style={{ marginRight: "10px", borderRadius: "5px" }}
                      size="small"
                      iconOnly
                    >
                      <Icon>add</Icon>
                    </CreateButton>
                  )}
                  {downloadTemplateAccess && (
                    <CSVLink {...csvLink2}>
                      <DownloadButton
                        tooltip="Download Template"
                        style={{ marginRight: "1rem", borderRadius: "5px" }}
                        size="small"
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadButton>
                    </CSVLink>
                  )}

                  {uploadAccess && (
                    <UploadButton
                      tooltip="Upload Asset Master"
                      style={{ marginRight: "1rem", borderRadius: "5px" }}
                      size="small"
                      type="button"
                      variant="outlined"
                      color="info"
                      iconOnly
                      onClick={uploadCsvFilterHandler}
                    >
                      <Icon>upload</Icon>
                    </UploadButton>
                  )}

                  {downloadAccess && (
                    <CSVLink {...csvLink}>
                      <DownloadDataButton
                        tooltip="Download Asset List"
                        style={{ marginRight: "1rem", borderRadius: "5px" }}
                        size="small"
                        type="button"
                        variant="outlined"
                        color="success"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadDataButton>
                    </CSVLink>
                  )}
                </MDBox>

                {uploadCsvFilter && (
                  <div>
                    <div>
                      <input
                        className="choose_file"
                        style={{
                          marginTop: "3.5rem",
                          marginLeft: "1.5rem",
                          // marginBottom: "-9rem",
                        }}
                        type="file"
                        accept=".csv"
                        onChange={(e) => {
                          setUploadCsvData(e.target.files[0]);
                        }}
                      />

                      <MDButton
                        disabled={
                          !uploadCsvData?.name ||
                          uploadCsvData?.type !== "text/csv"
                        }
                        variant="contained"
                        color="info"
                        style={{
                          marginLeft: { xs: "1.5rem", lg: "0" },
                          marginTop: "0rem",
                        }}
                        type="button"
                        onClick={uploadCsvHandler}
                      >
                        UPLOAD
                      </MDButton>
                    </div>
                    <div>
                      <span
                        style={{
                          color: "red",
                          fontSize: "14px",
                          marginLeft: "30px",
                          fontStyle: "italic",
                        }}
                      >
                        <strong>*</strong> Please upload
                        <strong>".csv"</strong> file only
                      </span>
                    </div>
                  </div>
                )}
                <Modal
                  open={openCreateColumnReorderModal}
                  onClose={handleCloseCreateColumnReorderModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={styleForColumnReorder}>
                    <MDTypography>
                      Are you sure you want to submit?
                    </MDTypography>
                    <MDBox mt={2}>
                      <MDButton
                        style={{ width: "10rem", marginRight: "0.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseCreateColumnReorderModal}
                      >
                        Cancel
                      </MDButton>
                      <MDButton
                        style={{ width: "10rem", marginLeft: "0.5rem" }}
                        color="success"
                        // onClick={handleDynamicColumn}
                        // disabled={denyButtonName === "Please wait..."}
                      >
                        Submit
                      </MDButton>
                    </MDBox>
                    <MDBox mt={2}>
                      <Collapse in={isSuccessColumnReorder}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessColumnReorder(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Data updated successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorColumnReorder}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorColumnReorder(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {isErrorMsgForColumnReorder}
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDCard>
                </Modal>
                <MDBox pt={3}>
                  {loadingForDynamicColumn && (
                    <DataTable
                      table={{ columns, rows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                      options={{ draggable: false }}
                      serverSidePagination={true}
                      paginationObj={paginationObj}
                      pageNoValue={pageNo}
                      rowsPerPageValue={rowsPerPage}
                      pageNoProp={importPageNo}
                      rowsPerPageProp={importRowsPerPage}
                      searchProp={importSearch}
                      loading={loading}
                      hideColumns={hiddenColumsDetails}
                      visibleColumns2={dynamicColumnData?.visibleFields}
                      dynamicColumnData={dynamicColumnData}
                      handleOpenCreateColumnReorderModal={
                        handleOpenCreateColumnReorderModal
                      }
                      subModuleId={subModuleId}
                      userId={userId}
                    />
                  )}
                </MDBox>
                <Modal
                  open={openCreateAssetModal}
                  onClose={handleCloseCreateAssetModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Create Asset
                      </MDTypography>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseCreateAssetModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForCreateAsset.handleSubmit}
                      >
                        <MDBox>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Select the Asset Type
                            </MDTypography>

                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={180}
                              placeholder="Select Asset Type..."
                              name="assetType"
                              value={assetTypeSelected}
                              options={assetTypeOptions}
                              onChange={(selectedOption) => {
                                handleAssetTypeChange(selectedOption);
                                formikForCreateAsset.setFieldValue(
                                  "assetType",
                                  selectedOption,
                                );
                              }}
                            />
                            {formikForCreateAsset.errors.assetType && (
                              <TextError
                                msg={formikForCreateAsset.errors.assetType}
                              />
                            )}
                          </MDBox>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Asset Code
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="assetCode"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForCreateAsset.handleBlur}
                              onChange={formikForCreateAsset.handleChange}
                              value={formikForCreateAsset.values.assetCode}
                              error={
                                formikForCreateAsset.touched.assetCode &&
                                formikForCreateAsset.errors.assetCode &&
                                true
                              }
                              inputProps={{
                                maxLength: 45,
                              }}
                            />
                            {formikForCreateAsset.errors.assetCode && (
                              <TextError
                                msg={formikForCreateAsset.errors.assetCode}
                              />
                            )}
                          </MDBox>
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Asset Description (Optional)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="assetName"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForCreateAsset.handleBlur}
                              onChange={formikForCreateAsset.handleChange}
                              value={formikForCreateAsset.values.assetName}
                              error={
                                formikForCreateAsset.touched.assetName &&
                                formikForCreateAsset.errors.assetName &&
                                true
                              }
                              inputProps={{
                                maxLength: 45,
                              }}
                            />
                            {formikForCreateAsset.errors.assetName && (
                              <TextError
                                msg={formikForCreateAsset.errors.assetName}
                              />
                            )}
                          </MDBox>
                          {assetTypeSelected?.value === 3 && (
                            <MDBox mb={2}>
                              <MDTypography
                                variant="h6"
                                style={{ fontWeight: 500 }}
                              >
                                IP
                              </MDTypography>
                              <MDInput
                                type="text"
                                name="ip"
                                fullWidth
                                autoComplete="off"
                                onBlur={formikForCreateAsset.handleBlur}
                                onChange={formikForCreateAsset.handleChange}
                                value={formikForCreateAsset.values.ip}
                                error={
                                  formikForCreateAsset.touched.ip &&
                                  formikForCreateAsset.errors.ip &&
                                  true
                                }
                              />
                              {formikForCreateAsset.errors.ip && (
                                <TextError
                                  msg={formikForCreateAsset.errors.ip}
                                />
                              )}
                            </MDBox>
                          )}
                          {assetTypeSelected?.value === 3 && (
                            <MDBox mb={2}>
                              <MDTypography
                                variant="h6"
                                style={{ fontWeight: 500 }}
                              >
                                Port
                              </MDTypography>
                              <MDInput
                                type="number"
                                name="port"
                                fullWidth
                                autoComplete="off"
                                onBlur={formikForCreateAsset.handleBlur}
                                onChange={formikForCreateAsset.handleChange}
                                value={formikForCreateAsset.values.port}
                                error={
                                  formikForCreateAsset.touched.port &&
                                  formikForCreateAsset.errors.port &&
                                  true
                                }
                              />
                              {formikForCreateAsset.errors.port && (
                                <TextError
                                  msg={formikForCreateAsset.errors.port}
                                />
                              )}
                            </MDBox>
                          )}
                          <MDBox mt={2}>
                            <Collapse in={isSuccessCreateNewAsset}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessCreateNewAsset(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Asset created successfully!
                              </Alert>
                            </Collapse>
                            <Collapse in={isErrorCreateNewAsset}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorCreateNewAsset(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {/* Could not create the Asset! */}
                                {errorMsgForCreate}
                              </Alert>
                            </Collapse>
                          </MDBox>

                          <div className="mt-3">
                            <MDButton
                              type="submit"
                              variant="gradient"
                              color="info"
                              fullWidth
                              disabled={
                                !formikForCreateAsset.isValid ||
                                (assetTypeSelected?.value === 3 &&
                                  formikForCreateAsset.values.ip == "") ||
                                (assetTypeSelected?.value === 3 &&
                                  formikForCreateAsset.values.port == "") ||
                                buttonName === "Please wait..."
                              }
                            >
                              {buttonName}
                            </MDButton>
                          </div>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openMapAssetModal}
                  onClose={handleCloseMapAssetModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h5"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Map
                      </MDTypography>
                      <MDBox>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseMapAssetModal}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForMapAsset.handleSubmit}
                      >
                        <MDBox mb={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            Select Type
                          </MDTypography>

                          <Select
                            isClearable
                            className="select-css"
                            maxMenuHeight={130}
                            placeholder="Choose one..."
                            name="type"
                            value={selectedType}
                            options={typeOptions}
                            onChange={(selectedOption) => {
                              handleTypeChange(selectedOption);

                              formikForMapAsset.setFieldValue(
                                "type",
                                selectedOption,
                              );
                            }}
                          />
                        </MDBox>
                        {selectedType && (
                          <MDBox mb={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {selectedType?.label}
                            </MDTypography>

                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={130}
                              placeholder="Choose one..."
                              name="master"
                              value={selectedMaster}
                              options={masterOptions}
                              onChange={(selectedOption) => {
                                handleMasterChange(selectedOption);
                                // formikForMapAsset.setFieldValue(
                                //   "master",
                                //   selectedOption
                                // );
                              }}
                            />
                          </MDBox>
                        )}
                        <MDBox>
                          <Collapse in={isErrorForMapAsset}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForMapAsset(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForMapAsset}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessForMapAsset}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForMapAsset(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Asset mapped successfully
                            </Alert>
                          </Collapse>
                        </MDBox>

                        <MDBox mt={3}>
                          <MDButton
                            color="success"
                            fullWidth
                            type="submit"
                            disabled={
                              !formikForMapAsset.isValid ||
                              !selectedType ||
                              !selectedMaster ||
                              mapButtonName === "Please wait..."
                            }
                          >
                            {mapButtonName}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openUpdateAssetModal}
                  onClose={handleCloseUpdateAssetModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={style}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Update
                      </MDTypography>
                      <MDBox>
                        <Tooltip title="Close">
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseUpdateAssetModal}
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </MDBox>
                    </MDBox>
                    <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                    <MDBox pt={1} pb={3} px={3}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForUpdate.handleSubmit}
                      >
                        <MDBox mb={2}>
                          <MDTypography variant="h6">
                            Asset Description
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="assetName"
                            fullWidth
                            autoComplete="off"
                            onBlur={formikForUpdate.handleBlur}
                            onChange={formikForUpdate.handleChange}
                            value={formikForUpdate.values.assetName}
                            error={
                              formikForUpdate.touched.assetName &&
                              formikForUpdate.errors.assetName &&
                              true
                            }
                            inputProps={{
                              maxLength: 45,
                            }}
                          />
                          {formikForUpdate.touched.assetName &&
                            formikForUpdate.errors.assetName && (
                              <TextError
                                msg={formikForUpdate.errors.assetName}
                              />
                            )}
                        </MDBox>
                        {singleAssetDataForUpdate?.assetTypeId === 5 && (
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              IP
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="printerIp"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.printerIp}
                              error={
                                formikForUpdate.touched.printerIp &&
                                formikForUpdate.errors.printerIp &&
                                true
                              }
                            />
                            {formikForUpdate.errors.printerIp && (
                              <TextError
                                msg={formikForUpdate.errors.printerIp}
                              />
                            )}
                          </MDBox>
                        )}
                        {singleAssetDataForUpdate?.assetTypeId === 5 && (
                          <MDBox mb={2}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Port
                            </MDTypography>
                            <MDInput
                              type="number"
                              name="printerPort"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.printerPort}
                              error={
                                formikForUpdate.touched.printerPort &&
                                formikForUpdate.errors.printerPort &&
                                true
                              }
                            />
                            {formikForUpdate.errors.printerPort && (
                              <TextError
                                msg={formikForUpdate.errors.printerPort}
                              />
                            )}
                          </MDBox>
                        )}
                        <MDBox>
                          <Collapse in={isErrorForUpdate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForUpdate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessForUpdate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorForUpdate(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Asset updated successfully
                            </Alert>
                          </Collapse>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            variant="contained"
                            color="success"
                            fullWidth
                            type="submit"
                            disabled={
                              !formikForUpdate.isValid ||
                              editButtonName === "Please wait..."
                            }
                          >
                            {editButtonName}
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openDeleteAssetModal}
                  onClose={handleCloseDeleteAssetModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={deleteStyle}>
                    <MDTypography>
                      Are you sure you want to delete?
                    </MDTypography>
                    <MDBox mt={2} display="flex">
                      <div>
                        <MDButton
                          style={{ width: "100%", marginRight: "0.5rem" }}
                          color="info"
                          variant="outlined"
                          onClick={handleCloseDeleteAssetModal}
                        >
                          Cancel
                        </MDButton>
                      </div>
                      <div style={{ float: "right" }}>
                        <MDButton
                          style={{ width: "100%", marginLeft: "0.5rem" }}
                          color="error"
                          onClick={deleteAssetData}
                          disabled={deleteButtonName === "Please wait..."}
                        >
                          {deleteButtonName}
                        </MDButton>
                      </div>
                    </MDBox>
                    <MDBox mt={2}>
                      <Collapse in={isSuccessDeleteAsset}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessDeleteAsset(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Asset deleted successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorDeleteAsset}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorDeleteAsset(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {errorMsgForDelete}
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openBinViewModal}
                  onClose={handleCloseViewBinModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <MDCard sx={styleForPicklistViewModal}>
                    <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                      <MDTypography
                        variant="h4"
                        fontWeight="medium"
                        flexGrow={1}
                      >
                        Asset Code: {rfid}
                      </MDTypography>

                      <MDBox>
                        <span>
                          <Tooltip title="Close">
                            <IconButton
                              style={{
                                background: "whitesmoke",
                                color: "black",
                                borderRadius: 5,
                                marginLeft: "-55px",
                                marginBottom: "5px",
                              }}
                              aria-label="close"
                              color="inherit"
                              onClick={handleCloseViewBinModal}
                            >
                              <CloseIcon />
                            </IconButton>
                          </Tooltip>
                        </span>
                      </MDBox>
                    </MDBox>
                    <MDBox>
                      {!loading2 ? (
                        <DataTable
                          table={{ columns: binColumns, rows: binRows }}
                          isSorted={true}
                          tableSearch={true}
                          entriesPerPage={{
                            defaultValue: 5,
                            entries: [5, 10, 15, 20, 25, 30],
                          }}
                          showTotalEntries={true}
                          noEndBorder
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "100px",
                            marginBottom: "100px",
                          }}
                        >
                          <CircularProgress color="info" />
                        </div>
                      )}
                    </MDBox>
                  </MDCard>
                </Modal>
                <Modal
                  open={openCreateColumnReorderModal}
                  onClose={handleCloseCreateColumnReorderModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  style={{ backdropFilter: "blur(5px)" }}
                >
                  <MDCard sx={styleForColumnReorder}>
                    <MDTypography>
                      Are you sure you want to submit?
                    </MDTypography>
                    <MDBox mt={2}>
                      <MDButton
                        style={{ width: "10rem", marginRight: "0.5rem" }}
                        color="info"
                        variant="outlined"
                        onClick={handleCloseCreateColumnReorderModal}
                      >
                        Cancel
                      </MDButton>
                      <MDButton
                        style={{ width: "10rem", marginLeft: "0.5rem" }}
                        color="success"
                        onClick={handleDynamicColumn}
                        // disabled={denyButtonName === "Please wait..."}
                      >
                        Submit
                      </MDButton>
                    </MDBox>
                    <MDBox mt={2}>
                      <Collapse in={isSuccessColumnReorder}>
                        <Alert
                          severity="success"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsSuccessColumnReorder(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          Data updated successfully!
                        </Alert>
                      </Collapse>
                      <Collapse in={isErrorColumnReorder}>
                        <Alert
                          severity="error"
                          action={
                            <IconButton
                              aria-label="close"
                              color="inherit"
                              size="small"
                              onClick={() => {
                                setIsErrorColumnReorder(false);
                              }}
                            >
                              <CloseIcon fontSize="inherit" />
                            </IconButton>
                          }
                        >
                          {isErrorMsgForColumnReorder}
                        </Alert>
                      </Collapse>
                    </MDBox>
                  </MDCard>
                </Modal>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        {loading && (
          <Backdrop
            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <ToastContainer />
        <Footer />
      </DashboardLayout>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getAssetsReducer: state.getAssetsReducer,
    getUnmappedBinsReducer: state.getUnmappedBinsReducer,
    getUnmappedPalletsReducer: state.getUnmappedPalletsReducer,
    assetTypes: state.getAssetTypesReducer,
    getMappedBinsByRifdReducer: state.getMappedBinsByRifdReducer,
    getDownloadAssetsReducer: state.getDownloadAssetsReducer,
    profileData: state.profile,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getAssets: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getAssets(pageNo, rowsPerPage, searchObject, jwtToken)),
    deleteAsset: (assetId, userId, jwtToken) =>
      dispatch(deleteAsset(assetId, userId, jwtToken)),

    getDownloadAssets: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getDownloadAssets(pageNo, rowsPerPage, searchObject, jwtToken)),
    createNewAsset: (payload, jwtToken) =>
      dispatch(createNewAsset(payload, jwtToken)),
    updateAsset: (payload, jwtToken) =>
      dispatch(updateAsset(payload, jwtToken)),
    mapAsset: (payload, type, jwtToken) =>
      dispatch(mapAsset(payload, type, jwtToken)),
    getAssetTypes: (jwtToken) => dispatch(getAssetTypes(jwtToken)),
    getBins: (jwtToken) => dispatch(getBins(jwtToken)),
    getUnmappedBins: (jwtToken) => dispatch(getUnmappedBins(jwtToken)),
    getUnmappedPallets: (jwtToken) => dispatch(getUnmappedPallets(jwtToken)),
    uploadAssetMaster: (payload, jwtToken) =>
      dispatch(uploadAssetMaster(payload, jwtToken)),
    getMappedBinsByRfid: (rfid, jwtToken) =>
      dispatch(getMappedBinsByRfid(rfid, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetMaster);
